// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"605":"7544e12b","676":"26065dcf"}[chunkId] + ".chunk.js";
};